// extracted by mini-css-extract-plugin
export default {"inputDiv":"orders_inputDiv__yTeJV","checkout":"orders_checkout__InZfZ","orderText":"orders_orderText__AxMjS"};